var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['z-lead', { 'z-lead--divider' : _vm.underline }]},[_vm._t("default"),_vm._v(" "),(_vm.underline)?_c('div',{staticClass:"z-lead__divider"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }